import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@devsbb/ui';
import Nessie from './assets/Nessie.svg';
import { Text } from '@/components/Text';
import { Container, Image, ErrorStyledText } from './styles';
import { tk } from '@/i18n/translationKeys';
import { logger } from '@/logger';
import { trackNotFoundPageShownEvent } from '@/analytics';
import { useApplicationData } from '@/providers/applicationData';
import { useTheme } from 'styled-components';

const hostBaseUrl = '/';

interface NotFoundProps {
  buttonHref?: string;
  buttonText?: string;
}

export const NotFound = ({ buttonHref, buttonText }: NotFoundProps): JSX.Element => {
  const { t } = useTranslation();
  const { userId, storeCode } = useApplicationData();
  const theme = useTheme();

  useEffect(() => {
    logger.error('404ErrorNotFoundShown');
    trackNotFoundPageShownEvent({ userId, store: storeCode });
  }, []);

  return (
    <Container data-testid="page-not-found" vertical gap={6} mobileGap={6}>
      <Image src={Nessie} />
      <Text centered typography="SmallCapsHeadline" color={theme.colors.text.darkerGrey}>
        {t(tk.pageNotFoundStatusText, { errorStatus: 404 })}
      </Text>
      <Text centered typography="SmallHeadline" color={theme.colors.text.darkerGrey}>
        {t(tk.pageNotFoundTitle)}
      </Text>
      <ErrorStyledText typography="RegularParagraph" color={theme.colors.text.darkerGrey}>
        {t(tk.pageNotFoundText)}
      </ErrorStyledText>
      <Button href={buttonHref || hostBaseUrl} variant="Primary" size="S">
        <Text typography="SuperTinyHeadline">{buttonText || t(tk.pageNotFoundButtonText)}</Text>
      </Button>
    </Container>
  );
};
